// extracted by mini-css-extract-plugin
export default {"top":"SongNew_top__Lq3ej","btn":"SongNew_btn__5P31Z"};